import { useCompanyInformation, RedirectState, useCurrentCompany } from '@neo.tax/shared';

export const useRdDataSourcesRedirect = (): RedirectState => {
  const { loading: loadingCompanyInformation } = useCompanyInformation();
  const { loading: loadingCompany } = useCurrentCompany();

  const isLoading = loadingCompanyInformation || loadingCompany;
  return { isLoading };
};
